var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"title-text"},[_vm._v("Verifying your token...")]),_c('LoadingSpinner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }